import create from 'zustand'

export const transactionsInitialData = []
const useTransactionsStore = create((set) => ({
  transactions: transactionsInitialData,
  transactionsLoading: true,
  setTransactionsLoading: (loading) => set({ transactionsLoading: loading }),
  setTransactions: (transactions) => set((state) => ({ ...state, transactions, transactionsLoading: false })),
  resetTransactions: () => set(() => ({
    transactions: transactionsInitialData,
    transactionsLoading: true
  }))
}))

export default useTransactionsStore
